<template>
	<div class="sidebar-container" :style="sidebarStyle" v-if="visible">
		<div class="sidebar-content">
			<!-- 一级菜单列表 -->
			<div class="first-level-menus">
				<!-- 工作台菜单（从接口获取，始终显示在第一个） -->
				<div v-if="dashboardMenu" class="menu-item dashboard-item" 
					:class="{ 'active': activeMenuId === dashboardMenu.id }"
					@mouseenter="handleDashboardHover(dashboardMenu, $event)"
					@mouseleave="handleMenuLeave"
					@click="handleDashboardClick(dashboardMenu)">
					<div class="menu-icon">
						<i :class="dashboardMenu.icon || 'el-icon-s-home'"></i>
					</div>
					<div class="menu-name">{{ dashboardMenu.name || dashboardMenu.title || '工作台' }}</div>
					<div class="menu-arrow">
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
 
				<!-- 动态菜单项（排除工作台菜单） -->
				<div v-for="menu in filteredFirstLevelMenus" :key="menu.id" class="menu-item"
					:class="{ 'active': activeMenuId === menu.id, 'hovered': hoveredMenuId === menu.id }"
					@mouseenter="handleMenuHover(menu, $event)"
					@mouseleave="handleMenuLeave"
					@click="handleFirstLevelMenuClick(menu)">
					<div class="menu-icon">
						<i :class="menu.icon || 'el-icon-menu'"></i>
					</div>
					<div class="menu-name">{{ menu.name || menu.title }}</div>
					<div class="menu-arrow">
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
			</div>
 
			<!-- 底部固定菜单 -->
			<div class="bottom-fixed-menus">
				
				<!-- 系统管理 -->
				<div v-if="systemManagementMenu" class="menu-item fixed-menu"
					:class="{ 'active': activeMenuId === systemManagementMenu.id }"
					@mouseenter="handleMenuHover(systemManagementMenu, $event)"
					@mouseleave="handleMenuLeave"
					@click="handleSystemManagementClick(systemManagementMenu)">
					<div class="menu-icon">
						<i :class="systemManagementMenu.icon || 'el-icon-setting'"></i>
					</div>
					<div class="menu-name">{{ systemManagementMenu.name || systemManagementMenu.title }}</div>
				</div>
			</div>
		</div>
		<!-- 子菜单弹出模态框 -->
		<div v-if="showSubMenuModal" class="submenu-modal" 
		  :style="modalStyle"
		  @mouseenter="handleModalEnter"
		  @mouseleave="handleModalLeave">
			
			<div class="modal-content" :style="{ maxHeight: modalStyle.maxHeight }">
				<!-- 模态框头部 -->
				<div class="modal-header">
					<div class="header-icon">
						<i :class="hoveredMenu.icon || 'el-icon-folder'"></i>
					</div>
					<div class="header-title">
						<h3>{{ hoveredMenu.name || hoveredMenu.title }}</h3>
						<p class="menu-description" v-if="hoveredMenu.description">{{ hoveredMenu.description }}</p>
					</div>
					<div class="header-close" @click="closeModal">
						<i class="el-icon-close"></i>
					</div>
				</div>

				<!-- 工作台特殊模态框内容 -->
				<div v-if="isHoveringDashboard" class="dashboard-modal-body">
					<!-- 选项卡切换 -->
					<div class="tab-header">
						<div class="tab-nav">
							<div class="tab-item" 
								:class="{ 'active': activeTab === 'base' }"
								@click="activeTab = 'base'">
								基础信息
							</div>
							<div class="tab-item" 
								:class="{ 'active': activeTab === 'flow' }"
								@click="activeTab = 'flow'">
								通用流程图
							</div>
						</div>
					</div>

					<!-- 选项卡内容 -->
					<div class="tab-content">
						<div v-show="activeTab === 'base'" class="tab-pane base-tab">
							<div class="empty-state">
								<i class="el-icon-folder-opened empty-icon"></i>
								<p class="empty-text">暂无基础信息内容</p>
								<p class="empty-subtext">当前工作台基础信息为空</p>
							</div>
						</div>

						<div v-show="activeTab === 'flow'" class="tab-pane flow-tab">
						    <div class="flow-chart-container">
						      <div class="flow-top-section">
						        <div class="flow-section left-section">
						          <div class="section-title">采购流程</div>
						          <div class="flow-steps">
						            <div class="flow-step">
						              <div class="flow-card" @click="navigateTo('/PSI/shopPlan')">
						                <div class="flow-icon"><i class="el-icon-document"></i></div>
						                <div class="flow-label">计划单</div>
						              </div>
						              <div class="flow-arrow"><i class="el-icon-arrow-right"></i></div>
						              <div class="flow-card" @click="navigateTo('/PSI/shopStore')">
						                <div class="flow-icon"><i class="el-icon-tickets"></i></div>
						                <div class="flow-label">采购单</div>
						              </div>
						              <div class="flow-arrow"><i class="el-icon-arrow-right"></i></div>
						              <div class="flow-card" @click="navigateTo('/PSI/shopReturn')">
						                <div class="flow-icon"><i class="el-icon-refresh-left"></i></div>
						                <div class="flow-label">调拨单</div>
						              </div>
						              <div class="flow-arrow"><i class="el-icon-arrow-right"></i></div>
						              <div class="flow-card" @click="navigateTo('/supplier/supplierPayableAmountRecord')">
						                <div class="flow-icon"><i class="el-icon-notebook-2"></i></div>
						                <div class="flow-label">供应商账本</div>
						              </div>
						            </div>
						          </div>
						        </div>
						        
						        <div class="flow-section right-section">
						          <div class="section-title">销售流程</div>
						          <div class="flow-steps">
						            <div class="flow-step">
						              <div class="flow-card" @click="navigateTo('/sales/order')">
						                <div class="flow-icon"><i class="el-icon-sold-out"></i></div>
						                <div class="flow-label">销售单</div>
						              </div>
						              <div class="flow-arrow"><i class="el-icon-arrow-right"></i></div>
						              <div class="flow-card" @click="navigateTo('/finance/payment')">
						                <div class="flow-icon"><i class="el-icon-money"></i></div>
						                <div class="flow-label">付款单</div>
						              </div>
						              <div class="flow-arrow"><i class="el-icon-arrow-right"></i></div>
						              <div class="flow-card" @click="navigateTo('/finance/receipt')">
						                <div class="flow-icon"><i class="el-icon-bank-card"></i></div>
						                <div class="flow-label">收款单</div>
						              </div>
						              <div class="flow-arrow"><i class="el-icon-arrow-right"></i></div>
						              <div class="flow-card" @click="navigateTo('/customer/ledger')">
						                <div class="flow-icon"><i class="el-icon-notebook-1"></i></div>
						                <div class="flow-label">客户账本</div>
						              </div>
						            </div>
						          </div>
						        </div>
						      </div>
						      
						      <div class="flow-bottom-section">
						        <div class="section-title">常用功能</div>
						        <div class="function-buttons">
						          <el-button class="func-btn" @click="navigateTo('/Western')">西药</el-button>
						          <el-button class="func-btn" @click="navigateTo('/systemCatalogue/traMedici')">中药</el-button>
						          <el-button class="func-btn" @click="navigateTo('/reservation/outpatientPhysician')">门诊医师</el-button>
						          <el-button class="func-btn" @click="navigateTo('/reservation/westernMedicineList/westernMedicineList')">处方</el-button>
						          <el-button class="func-btn" @click="navigateTo('/reservation/outpatientCharge')">收费</el-button>
						          <el-button class="func-btn" @click="navigateTo('/medicenHouse/WesternHouse/giveMedici')">发药</el-button>
						          <el-button class="func-btn" @click="navigateTo('medicenHouse/WesternHouse/returnMedici')">退药</el-button>
						          <el-button class="func-btn" @click="navigateTo('/customer/contractDept')">往来单位</el-button>
						          <el-button class="func-btn" @click="navigateTo('/DrugInventory/xyk')">现存量（库存记录表）</el-button>
						          <el-button class="func-btn" @click="navigateTo('/DrugInventory/xyk')">流向记录（库存明细表）</el-button>
						          <el-button class="func-btn" @click="navigateTo('/analysis/sales-profit')">销售毛利分析表</el-button>
						          <el-button class="func-btn" @click="navigateTo('/analysis/profit')">毛利分析</el-button>
						          <el-button class="func-btn" @click="navigateTo('/supplier')">供货单位</el-button>
						          <el-button class="func-btn" @click="navigateTo('/supplier/supplierPayableAmountRecord')">付款情况统计</el-button>
						        </div>
						      </div>
						    </div>
						  </div>
					</div>
				</div>

				<!-- 其他菜单的模态框内容 -->
				<div v-else class="modal-body">
					<!-- 左侧：可点击菜单区域 -->
					<div class="menu-columns">
						<!-- 基础信息区域 (jc) -->
						<div class="menu-column basic-info-column" v-if="basicInfoMenus.length > 0">
							<div class="column-header">
								<i class="el-icon-document"></i>
								<span class="column-title">基础信息</span>
								<el-tag size="mini" type="info">{{ basicInfoMenus.length }}</el-tag>
							</div>
							<div class="column-content">
								<div v-for="subMenu in basicInfoMenus" :key="subMenu.id" 
									class="submenu-item clickable"
									@click="handleSubMenuClick(subMenu)">
									<div class="submenu-icon">
										<i :class="subMenu.icon || 'el-icon-document'"></i>
									</div>
									<div class="submenu-info">
										<div class="submenu-name">{{ subMenu.name || subMenu.title }}</div>
										<div class="submenu-desc" v-if="subMenu.description">{{ subMenu.description }}</div>
									</div>
									<div class="submenu-arrow">
										<i class="el-icon-arrow-right"></i>
									</div>
								</div>
							</div>
						</div>
					
						<!-- 功能菜单区域 (gn) -->
						<div class="menu-column function-menu-column" v-if="functionMenus.length > 0">
							<div class="column-header">
								<i class="el-icon-menu"></i>
								<span class="column-title">功能区</span>
								<el-tag size="mini" type="success">{{ functionMenus.length }}</el-tag>
							</div>
							<div class="column-content">
								<div v-for="subMenu in functionMenus" :key="subMenu.id" 
									class="submenu-item clickable"
									@click="handleSubMenuClick(subMenu)">
									<div class="submenu-icon">
										<i :class="subMenu.icon || 'el-icon-menu'"></i>
									</div>
									<div class="submenu-info">
										<div class="submenu-name">{{ subMenu.name || subMenu.title }}</div>
										<div class="submenu-desc" v-if="subMenu.description">{{ subMenu.description }}</div>
									</div>
									<div class="submenu-arrow">
										<i class="el-icon-arrow-right"></i>
									</div>
								</div>
							</div>
						</div>
					
						<!-- 统计区域 (bb) -->
						<div class="menu-column statistics-column" v-if="statisticsMenus.length > 0">
							<div class="column-header">
								<i class="el-icon-data-analysis"></i>
								<span class="column-title">统计区</span>
								<el-tag size="mini" type="warning">{{ statisticsMenus.length }}</el-tag>
							</div>
							<div class="column-content">
								<div v-for="subMenu in statisticsMenus" :key="subMenu.id" 
									class="submenu-item clickable"
									@click="handleSubMenuClick(subMenu)">
									<div class="submenu-icon">
										<i :class="subMenu.icon || 'el-icon-data-board'"></i>
									</div>
									<div class="submenu-info">
										<div class="submenu-name">{{ subMenu.name || subMenu.title }}</div>
										<div class="submenu-desc" v-if="subMenu.description">{{ subMenu.description }}</div>
									</div>
									<div class="submenu-arrow">
										<i class="el-icon-arrow-right"></i>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 右侧：权限按钮区域 (type为F) -->
					<div class="permission-column" v-if="permissionButtons.length > 0">
						<div class="column-header">
							<i class="el-icon-key"></i>
							<span class="column-title">权限按钮</span>
							<el-tag size="mini" type="danger">{{ permissionButtons.length }}</el-tag>
						</div>
						<div class="permission-content">
							<div class="permission-grid">
								<div v-for="button in permissionButtons" :key="button.id" 
									class="permission-button"
									:class="getButtonType(button)">
									<div class="button-icon">
										<i :class="button.icon || 'el-icon-star'"></i>
									</div>
									<div class="button-info">
										<div class="button-name">{{ button.name || button.title }}</div>
										<div class="button-desc" v-if="button.description">{{ button.description }}</div>
									</div>
									<el-tooltip v-if="button.description" :content="button.description" placement="top">
										<i class="el-icon-info info-icon"></i>
									</el-tooltip>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 模态框底部 -->
				<div class="modal-footer">
					<div class="footer-info">
						<span v-if="isHoveringDashboard" class="menu-count">
							{{ activeTab === 'base' ? '基础信息' : '通用流程图' }}
						</span>
						<span v-else class="menu-count">共 {{ totalSubMenus }} 个子菜单</span>
						<span class="button-count" v-if="!isHoveringDashboard && permissionButtons.length > 0">
							包含 {{ permissionButtons.length }} 个权限按钮
						</span>
					</div>
					<div class="footer-actions">
						<el-button size="mini" @click="closeModal">关闭</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/directive/event-bus.js';

export default {
  name: 'Sidebar',
  data() {
    return {
      visible: false,
      activeMenuId: null,
      currentBackground: null,
      navMenus: [],
      originalNavMenus: [],
      stockManagementVisible: true,
      dashboardMenu: null,
      msfxVisible: true,
      browserZoomLevel: 1,
      zoomCheckTimer: null,
      
      messageManagementMenu: {
        id: 'message-management',
        name: '消息管理',
        icon: 'el-icon-message',
        type: 'fixed',
        path: '/messages'
      },
      
      showSubMenuModal: false,
      hoveredMenu: null,
      hoveredMenuId: null,
      modalStyle: {
        top: '0px',
        left: '100%'
      },
      modalTimer: null,
      isModalHovered: false,
      currentMode: 'tree',
      basicInfoMenus: [],
      functionMenus: [],
      statisticsMenus: [],
      permissionButtons: [],
      isHoveringDashboard: false,
      activeTab: 'base'
    }
  },
  computed: {
    systemManagementMenu() {
      if (!this.originalNavMenus || !Array.isArray(this.originalNavMenus)) return null;
      const systemMenu = this.originalNavMenus.find(menu =>
        (menu.name === '系统管理' || menu.title === '系统管理') && menu.type !== 'F'
      );
      if (systemMenu) {
        return this.processMenuForRouter(systemMenu);
      }
      return null;
    },
    hoveredMenuName() {
      if (!this.hoveredMenu) return '菜单';
      return this.hoveredMenu.name || this.hoveredMenu.title || '菜单';
    },
    filteredFirstLevelMenus() {
      if (!this.navMenus || !Array.isArray(this.navMenus)) return [];
      return this.navMenus
        .filter(menu => {
          if (this.isDashboardMenu(menu)) return false;
          const isValidMenu = menu.type !== 'F' && (menu.name || menu.title) &&
            menu.name !== '系统管理' && menu.title !== '系统管理';
          if (this.isStockManagementMenu(menu)) {
            return isValidMenu && this.stockManagementVisible;
          }
          if (this.isMsfxMenu(menu)) {
            return isValidMenu && this.msfxVisible;
          }
          return isValidMenu;
        })
        .map(menu => this.processMenuForRouter(menu));
    },
    sidebarStyle() {
      return {
        backgroundColor: '#ffffff',
        color: '#303133',
        borderRight: '1px solid #e4e7ed'
      };
    },
    totalSubMenus() {
      return this.basicInfoMenus.length + this.functionMenus.length + this.statisticsMenus.length;
    }
  },
  
  mounted() {
    const cachedMenus = sessionStorage.getItem('navMenus');
    if (cachedMenus) {
      try {
        const menus = JSON.parse(cachedMenus);
        this.handleNavMenusUpdate(menus);
      } catch (e) {
        console.error('解析本地缓存的 navMenus 失败:', e);
      }
    }
  
    this.detectBrowserZoom();
    window.addEventListener('resize', this.handleResize);
    EventBus.$on('background-change', this.handleBackgroundChange);
    EventBus.$on('menu-mode-change', this.handleMenuModeChange);
    EventBus.$on('nav-menus-update', this.handleNavMenusUpdate);
    EventBus.$on('show-sidebar-menu', this.handleShowSidebar);
    EventBus.$on('hide-sidebar', this.handleHideSidebar);
    EventBus.$on('stock-management-visibility-change', this.handleStockManagementVisibilityChange);
    EventBus.$on('msfx-switch-change', this.handleMsfxSwitchChange);
    const savedMode = localStorage.getItem('menuMode') || 'tree';
    this.currentMode = savedMode;
    this.initMsfxVisible();
  },
  beforeDestroy() {
    EventBus.$off('background-change', this.handleBackgroundChange);
    EventBus.$off('menu-mode-change', this.handleMenuModeChange);
    EventBus.$off('nav-menus-update', this.handleNavMenusUpdate);
    EventBus.$off('show-sidebar-menu', this.handleShowSidebar);
    EventBus.$off('hide-sidebar', this.handleHideSidebar);
    EventBus.$off('stock-management-visibility-change', this.handleStockManagementVisibilityChange);
    EventBus.$off('msfx-switch-change', this.handleMsfxSwitchChange);
    window.removeEventListener('resize', this.handleResize);
    if (this.zoomCheckTimer) {
      clearTimeout(this.zoomCheckTimer);
    }
  },
  methods: {
    initMsfxVisible() {
      try {
        const storedMsfxVisible = localStorage.getItem('msfxVisible');
        if (storedMsfxVisible !== null) {
          this.msfxVisible = storedMsfxVisible === 'true';
        } else {
          this.msfxVisible = true;
          localStorage.setItem('msfxVisible', 'true');
        }
      } catch (error) {
        this.msfxVisible = true;
      }
    },
    async getSystemMsfxSwitchStatus() {
      try {
        this.msfxVisible = true;
      } catch (error) {
        this.msfxVisible = true;
      }
    },
    processMenuForRouter(menu) {
      if (!menu) return menu;
      const processedMenu = {
        ...menu,
        id: menu.id || menu.menuId,
        name: menu.name || menu.title,
        component: menu.component || '',
        path: menu.path || this.generateDefaultPath(menu)
      };
      if (menu.children && Array.isArray(menu.children)) {
        const validChildren = menu.children
          .filter(child => child.type !== 'F')
          .map(child => this.processMenuForRouter(child));
        if (validChildren.length > 0) {
          processedMenu.children = validChildren;
        }
      }
      return processedMenu;
    },
    generateDefaultPath(menu) {
      const name = (menu.name || menu.title || '').toLowerCase().replace(/\s+/g, '-');
      return `/${name}`;
    },
    handleStockManagementVisibilityChange(isVisible) {
      this.stockManagementVisible = isVisible;
      if (!isVisible && this.activeMenuId && this.isStockManagementMenu({ name: this.activeMenuId })) {
        this.activeMenuId = 'dashboard';
        this.$router.push('/home');
      }
      this.$forceUpdate();
    },
    handleMsfxSwitchChange(isVisible) {
      this.msfxVisible = isVisible;
      try {
        localStorage.setItem('msfxVisible', isVisible.toString());
      } catch (error) {}
      if (!isVisible && this.activeMenuId && this.isMsfxMenu({ name: this.activeMenuId })) {
        this.activeMenuId = 'dashboard';
        this.$router.push('/home');
      }
      this.$forceUpdate();
    },
    isStockManagementMenu(menu) {
      const menuName = (menu.name || menu.title || '').trim();
      return menuName === '库房管理' || menuName.includes('库房管理') && !menuName.includes('系统');
    },
    isMsfxMenu(menu) {
      const menuName = (menu.name || menu.title || '').trim();
      const msfxKeywords = ['码上放心', '马上放心', '追溯码', 'msfx'];
      return msfxKeywords.some(keyword => menuName.includes(keyword) || menuName === keyword);
    },
    handleHideSidebar() {
      this.visible = false;
      EventBus.$emit('sidebar-visibility-change', false);
      this.closeModal();
    },
    handleBackgroundChange(background) {
      this.currentBackground = background;
    },
    handleMenuModeChange(mode) {
      this.currentMode = mode;
      if (mode === 'tree') {
        this.visible = true;
        this.activeMenuId = 'dashboard';
        EventBus.$emit('sidebar-visibility-change', true);
      } else {
        this.visible = false;
        EventBus.$emit('sidebar-visibility-change', false);
        this.$nextTick(() => {
          this.visible = false;
        });
      }
    },
    handleShowSidebar() {
      if (this.currentMode === 'flow') return;
      this.visible = true;
      EventBus.$emit('sidebar-visibility-change', true);
    },
    isDashboardMenu(menu) {
      const menuName = (menu.name || menu.title || '').trim().toLowerCase();
      return menuName === '工作台' || menuName === 'dashboard' || menuName.includes('工作台');
    },
    handleNavMenusUpdate(navMenus) {
      if (navMenus && Array.isArray(navMenus)) {
        this.originalNavMenus = JSON.parse(JSON.stringify(navMenus));
        this.navMenus = navMenus.map(menu => this.processMenuForRouter(menu));
        this.extractDashboardMenu(navMenus);
        const hasStockManagement = this.navMenus.some(menu => this.isStockManagementMenu(menu));
        if (hasStockManagement) {
          this.stockManagementVisible = true;
        }
      }
    },
    extractDashboardMenu(menus) {
      if (!menus || !Array.isArray(menus)) {
        this.dashboardMenu = this.createDefaultDashboardMenu();
        return;
      }
      const findDashboardMenu = (menuList) => {
        for (const menu of menuList) {
          if (this.isDashboardMenu(menu)) return menu;
          if (menu.children && menu.children.length > 0) {
            const found = findDashboardMenu(menu.children);
            if (found) return found;
          }
        }
        return null;
      };
      const dashboardMenu = findDashboardMenu(menus);
      if (dashboardMenu) {
        this.dashboardMenu = this.processMenuForRouter(dashboardMenu);
        if (!this.dashboardMenu.path) this.dashboardMenu.path = '/index';
      } else {
        this.dashboardMenu = this.createDefaultDashboardMenu();
      }
    },
    createDefaultDashboardMenu() {
      return {
        id: 'dashboard',
        name: '工作台',
        title: '工作台',
        icon: 'el-icon-s-home',
        path: '/index',
        type: 'C'
      };
    },
    handleDashboardClick(menu) {
      this.activeMenuId = menu.id;
      this.$router.push('/home');
    },
    
    // ★★★ 修复：点击一级目录，不再追加面包屑
    handleFirstLevelMenuClick(menu) {
      this.activeMenuId = menu.id;
      // 移除了 add-breadcrumb
      this.sendMenuDataToRouter(menu);
    },
    
    handleSystemManagementClick(menu) {
      this.activeMenuId = menu.id;
      // 移除了 add-breadcrumb
      this.sendMenuDataToRouter(menu);
    },

    // 悬浮框里的二级菜单点击处理（属于具体页面，追加面包屑）
    handleSubMenuClick(subMenu) {
      this.activeMenuId = subMenu.id;
      
      EventBus.$emit('add-breadcrumb', {
        title: subMenu.name || subMenu.title,
        path: subMenu.path || this.$route.path,
        payload: { menu: subMenu }
      });

      if (subMenu.path) {
        this.navigateTo(subMenu.path);
        return;
      }
      this.sendMenuDataToRouter(subMenu);
    },
    
    sendMenuDataToRouter(menuData) {
      const menuPayload = {
        menu: menuData,
        parentMenu: {
          id: menuData.id || menuData.menuId,
          name: menuData.name || menuData.title,
          icon: menuData.icon
        },
        timestamp: Date.now(),
        displayMode: 'multi-level-group'
      };
      EventBus.$emit('menu-data-update', menuPayload);
      sessionStorage.setItem('pendingMenuData', JSON.stringify(menuPayload));
      sessionStorage.setItem('currentParentMenu', JSON.stringify(menuPayload.parentMenu));
      sessionStorage.setItem('navMenus', JSON.stringify(this.originalNavMenus));
      setTimeout(() => {
        this.$router.push('/Router');
      }, 50);
    },
    handleFixedMenuClick(menu) {
      this.activeMenuId = menu.id;
      if (menu.id === 'suggested-storage') {
         this.navigateTo(menu.path);
         return;
      }
      this.sendMenuDataToRouter(menu);
    },
    handleDashboardHover(menu, event) {
      this.isHoveringDashboard = true;
      this.activeTab = 'base';
      this.handleMenuHover(menu, event);
    },
    handleMenuHover(menu, event) {
      try {
        clearTimeout(this.modalTimer);
        this.hoveredMenu = menu;
        this.hoveredMenuId = menu.id;
        if (!event || !event.currentTarget) {
          const menuElement = this.getMenuElementById(menu.id);
          if (menuElement) {
            event = { currentTarget: menuElement };
          } else {
            this.setModalPositionWithDefault(menu);
          }
        }
        if (event && event.currentTarget) {
          this.setModalPosition(menu, event);
        }
        if (!this.isDashboardMenu(menu)) {
          this.processSubMenus(menu);
          this.isHoveringDashboard = false;
        }
        this.modalTimer = setTimeout(() => {
          this.showSubMenuModal = true;
        }, 200);
      } catch (error) {
        this.setModalPositionWithDefault(menu);
      }
    },
    setModalPositionWithDefault(menu) {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      let modalWidth = 800;
      let modalHeight = this.isDashboardMenu(menu) ? 700 : 600;
      const menuIndex = this.getMenuIndex(menu);
      let top;
      if (menuIndex >= 2) {
        top = (windowHeight - modalHeight) / 2;
      } else {
        top = windowHeight * 0.2;
      }
      let left = windowWidth - modalWidth - 20;
      if (left < 20) left = 20;
      this.modalStyle = {
        top: `${Math.max(10, top)}px`,
        left: `${left}px`,
        maxHeight: `${Math.min(modalHeight, windowHeight - 20)}px`,
        width: `${modalWidth}px`
      };
    },
    setModalPosition(menu, event) {
      const menuElement = event.currentTarget;
      const rect = menuElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      let modalWidth = 800;
      let modalHeight = 600;
      if (this.isDashboardMenu(menu)) {
        modalHeight = 700;
      } else {
        modalHeight = this.calculateModalHeightForMenu(menu);
      }
      const menuIndex = this.getMenuIndex(menu);
      let top, left;
      left = rect.right;
      const spaceRight = windowWidth - rect.right;
      if (spaceRight < modalWidth) {
        left = Math.max(10, rect.left - modalWidth);
      }
      if (menuIndex >= 2) {
        top = this.calculateCenteredTopPosition(modalHeight, windowHeight, rect);
      } else {
        top = this.calculateDefaultTopPosition(rect, modalHeight, windowHeight);
      }
      this.modalStyle = {
        top: `${top}px`,
        left: `${left}px`,
        maxHeight: `${Math.min(modalHeight, windowHeight - 20)}px`,
        width: `${modalWidth}px`
      };
    },
    calculateCenteredTopPosition(modalHeight, windowHeight, rect) {
      const centerPosition = (windowHeight - modalHeight) / 2;
      const minTop = 10;
      const maxTop = windowHeight - modalHeight - 10;
      return Math.max(minTop, Math.min(maxTop, centerPosition));
    },
    calculateDefaultTopPosition(rect, modalHeight, windowHeight) {
      let top = rect.top;
      const spaceBelow = windowHeight - rect.bottom;
      const spaceAbove = rect.top;
      if (spaceBelow < modalHeight && spaceAbove >= modalHeight) {
        top = Math.max(10, rect.top - modalHeight + rect.height);
      } else if (spaceBelow < modalHeight && spaceAbove < modalHeight) {
        const maxAvailableHeight = Math.min(modalHeight, Math.max(spaceBelow, spaceAbove) - 20);
        modalHeight = maxAvailableHeight;
        top = Math.max(10, rect.top);
      }
      return top;
    },
    getMenuIndex(menu) {
      if (!menu) return -1;
      const allFirstLevelMenus = [this.dashboardMenu, ...this.filteredFirstLevelMenus].filter(Boolean);
      return allFirstLevelMenus.findIndex(m => m && m.id === menu.id);
    },
    calculateModalHeightForMenu(menu) {
      if (!menu.children || !Array.isArray(menu.children)) return 500;
      let totalItems = 0;
      menu.children.forEach(child => {
        totalItems += 1;
      });
      if (totalItems <= 5) return 400;
      if (totalItems <= 10) return 500;
      if (totalItems <= 15) return 600;
      return 700;
    },
    handleMenuLeave() {
      clearTimeout(this.modalTimer);
      if (!this.isModalHovered) {
        this.modalTimer = setTimeout(() => {
          if (!this.isModalHovered) this.closeModal();
        }, 300);
      }
    },
    handleModalEnter() {
      this.isModalHovered = true;
      clearTimeout(this.modalTimer);
    },
    handleModalLeave() {
      this.isModalHovered = false;
      this.modalTimer = setTimeout(() => {
        this.closeModal();
      }, 300);
    },
    closeModal() {
      this.showSubMenuModal = false;
      this.hoveredMenu = null;
      this.hoveredMenuId = null;
      this.isModalHovered = false;
      this.isHoveringDashboard = false;
      clearTimeout(this.modalTimer);
    },
    processSubMenus(menu) {
      this.basicInfoMenus = [];
      this.functionMenus = [];
      this.statisticsMenus = [];
      this.permissionButtons = [];
      if (!menu.children || !Array.isArray(menu.children)) return;
      menu.children.forEach(child => {
        if (child.type === 'F') {
          this.permissionButtons.push(child);
          return;
        }
        const component = (child.component || '').toLowerCase();
        if (component.includes('jc')) {
          this.basicInfoMenus.push(child);
        } else if (component.includes('gn')) {
          this.functionMenus.push(child);
        } else if (component.includes('bb')) {
          this.statisticsMenus.push(child);
        } else {
          this.functionMenus.push(child);
        }
      });
    },
    getButtonType(button) {
      const name = (button.name || button.title || '').toLowerCase();
      if (name.includes('添加') || name.includes('新增') || name.includes('创建')) return 'button-add';
      if (name.includes('编辑') || name.includes('修改') || name.includes('更新')) return 'button-edit';
      if (name.includes('删除') || name.includes('移除') || name.includes('清理')) return 'button-delete';
      if (name.includes('查看') || name.includes('详情') || name.includes('预览')) return 'button-view';
      if (name.includes('导出') || name.includes('下载') || name.includes('打印')) return 'button-export';
      if (name.includes('导入') || name.includes('上传')) return 'button-import';
      return 'button-default';
    },
    handleResize() {
      if (this.zoomCheckTimer) clearTimeout(this.zoomCheckTimer);
      this.zoomCheckTimer = setTimeout(() => {
        this.detectBrowserZoom();
        if (this.showSubMenuModal && this.hoveredMenu) {
          this.recalculateModalPosition();
        }
      }, 300);
    },
    detectBrowserZoom() {
      try {
        this.browserZoomLevel = window.devicePixelRatio || 1;
      } catch (e) {}
    },
    recalculateModalPosition() {
      if (!this.hoveredMenu) return;
      const menuElement = this.getMenuElementById(this.hoveredMenu.id);
      if (menuElement) {
        this.setModalPosition(this.hoveredMenu, { currentTarget: menuElement });
      }
    },
    getMenuElementById(menuId) {
      if (!menuId) return null;
      const menuElements = document.querySelectorAll('.menu-item');
      for (let element of menuElements) {
        const nameElement = element.querySelector('.menu-name');
        if (nameElement) {
          const menuName = this.getMenuNameById(menuId);
          if (nameElement.textContent.includes(menuName)) return element;
        }
      }
      return null;
    },
    getMenuNameById(menuId) {
      if (this.dashboardMenu && this.dashboardMenu.id === menuId) {
        return this.dashboardMenu.name || this.dashboardMenu.title;
      }
      const menu = this.filteredFirstLevelMenus.find(m => m.id === menuId);
      if (menu) return menu.name || menu.title;
      return '';
    },
    navigateTo(path) {
      if (path && path !== '') {
        this.closeModal();
        setTimeout(() => {
          this.$router.push(path);
        }, 100);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.sidebar-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #ffffff !important;
  color: #303133 !important;
  border-right: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  overflow: visible;
}

.sidebar-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  min-height: 0;
}

.first-level-menus {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px;
  min-height: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  margin-bottom: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  color: #606266;
  position: relative;

  &:hover {
    background: #f5f7fa;
    border-color: #409eff;
    color: #303133;
    transform: translateX(5px);
    .menu-arrow {
      opacity: 1;
      transform: translateX(3px);
    }
  }

  &.active {
    background: #ecf5ff;
    color: #409eff;
    font-weight: 500;
    border-color: #b3d8ff;
  }

  .menu-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    i {
      font-size: 18px;
      color: inherit;
    }
  }

  .menu-name {
    font-size: 14px;
    flex: 1;
    font-weight: 500;
    color: inherit;
  }

  .menu-arrow {
    opacity: 0;
    transition: all 0.3s ease;
    i {
      font-size: 14px;
      color: #c0c4cc;
    }
  }
}

.bottom-fixed-menus {
  padding: 15px;
  border-top: 1px solid #e4e7ed;
  background: #fafbfc;
  flex-shrink: 0;
}

/* 子菜单模态框样式 */
.submenu-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.2s ease;

  .modal-content {
    width: 800px;
    max-height: 600px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    color: #333333;

    .modal-header {
      display: flex;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #e6e6e6;
      background: #fafbfc;

      .header-icon {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        background: linear-gradient(135deg, #409EFF, #66b1ff);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;

        i {
          font-size: 20px;
          color: white;
        }
      }

      .header-title {
        flex: 1;

        h3 {
          margin: 0 0 4px 0;
          font-size: 16px;
          color: #303133;
          font-weight: 600;
        }

        .menu-description {
          margin: 0;
          font-size: 12px;
          color: #909399;
        }
      }

      .header-close {
        width: 32px;
        height: 32px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: #f5f7fa;
        }

        i {
          font-size: 16px;
          color: #909399;
        }
      }
    }

    /* 工作台特殊模态框样式 */
    .dashboard-modal-body {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 400px;

      .tab-header {
        padding: 0 20px;
        border-bottom: 1px solid #e6e6e6;
        background: #f8f9fa;

        .tab-nav {
          display: flex;

          .tab-item {
            padding: 12px 20px;
            cursor: pointer;
            border-bottom: 2px solid transparent;
            transition: all 0.3s ease;
            color: #606266;
            font-weight: 500;

            &.active {
              color: #409EFF;
              border-bottom-color: #409EFF;
              background: rgba(64, 158, 255, 0.05);
            }

            &:hover:not(.active) {
              color: #303133;
              background: rgba(64, 158, 255, 0.02);
            }
          }
        }
      }

      .tab-content {
        flex: 1;
        overflow-y: auto;
        padding: 20px;

        .tab-pane {
          height: 100%;
        }

        .base-tab {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;

          .empty-state {
            text-align: center;
            color: #909399;

            .empty-icon {
              font-size: 48px;
              color: #c0c4cc;
              margin-bottom: 16px;
            }

            .empty-text {
              font-size: 16px;
              margin-bottom: 8px;
            }

            .empty-subtext {
              font-size: 14px;
            }
          }
        }

        .flow-tab {
          height: 100%;
          display: flex;
          flex-direction: column;

          .flow-chart-container {
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 100%;
            padding: 0;
            overflow: hidden;
          }
        }

        .flow-top-section {
          flex: 1;
          display: flex;
          margin-bottom: 20px;
          min-height: 0;

          .flow-section {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 20px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

            &.left-section { margin-right: 10px; }
            &.right-section { margin-left: 10px; }

            .section-title {
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 20px;
              color: #303133;
              padding-bottom: 10px;
              border-bottom: 1px solid #e6e6e6;
            }

            .flow-steps {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;

              .flow-step {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                .flow-card {
                  width: 48px;
                  height: 48px;
                  border-radius: 6px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  transition: all 0.3s ease;
                  background: linear-gradient(135deg, #409EFF, #66b1ff);
                  color: white;
                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                  &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                  }

                  .flow-icon {
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 4px;

                    i {
                      font-size: 16px;
                      color: inherit;
                    }
                  }

                  .flow-label {
                    font-size: 10px;
                    text-align: center;
                    line-height: 1.2;
                    font-weight: 500;
                  }
                }

                .flow-arrow {
                  margin: 0 15px;
                  color: #409EFF;
                  font-size: 16px;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  i {
                    animation: pulse 2s infinite;
                  }

                  @keyframes pulse {
                    0% { transform: translateX(0); opacity: 0.7; }
                    50% { transform: translateX(3px); opacity: 1; }
                    100% { transform: translateX(0); opacity: 0.7; }
                  }
                }
              }
            }
          }
        }

        .flow-bottom-section {
          background: #fff;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          flex-shrink: 0;

          .section-title {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 15px;
            color: #303133;
            padding-bottom: 10px;
            border-bottom: 1px solid #e6e6e6;
          }

          .function-buttons {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;

            .func-btn {
              min-width: 120px;
              margin: 0;
              background: #f5f7fa;
              border-color: #dcdfe6;
              color: #606266;

              &:hover {
                background: #ecf5ff;
                border-color: #c6e2ff;
                color: #409eff;
              }
            }
          }
        }

        @media (max-width: 1200px) {
          .flow-top-section {
            flex-direction: column;
            .flow-section {
              margin: 0 0 10px 0 !important;
              .flow-step { justify-content: space-around; }
            }
          }
        }

        @media (max-width: 768px) {
          .flow-top-section {
            .flow-section {
              padding: 15px;
              .flow-step {
                flex-wrap: wrap;
                justify-content: center;
                .flow-card { margin: 5px; }
                .flow-arrow { margin: 0 5px; }
              }
            }
          }

          .flow-bottom-section {
            padding: 15px;
            .function-buttons {
              justify-content: center;
              .func-btn { min-width: 100px; font-size: 12px; }
            }
          }
        }

        @media (hover: none) and (pointer: coarse) {
          .flow-card:hover { transform: none !important; }
        }
      }
    }

    .modal-body {
      flex: 1;
      display: flex;
      overflow: hidden;
      min-height: 400px;

      .menu-columns {
        flex: 3;
        display: flex;
        overflow: hidden;
        border-right: 1px solid #e6e6e6;

        .menu-column {
          flex: 1;
          display: flex;
          flex-direction: column;
          border-right: 1px solid #f0f0f0;

          &:last-child { border-right: none; }

          .column-header {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            background: #f8f9fa;
            border-bottom: 1px solid #e6e6e6;

            i { font-size: 14px; color: #409EFF; margin-right: 8px; }
            .column-title { flex: 1; font-size: 14px; font-weight: 600; color: #606266; }
            .el-tag { margin-left: 8px; }
          }

          .column-content {
            flex: 1;
            overflow-y: auto;
            padding: 8px 0;

            .submenu-item {
              display: flex;
              align-items: center;
              padding: 10px 16px;
              margin: 0 8px;
              border-radius: 4px;
              transition: all 0.2s ease;
              cursor: pointer;

              &.clickable:hover {
                background: #f0f7ff;
                transform: translateX(2px);
                .submenu-arrow { opacity: 1; transform: translateX(2px); }
              }

              .submenu-icon {
                width: 32px;
                height: 32px;
                border-radius: 6px;
                background: #f0f2f5;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;
                i { font-size: 16px; color: #409EFF; }
              }

              .submenu-info {
                flex: 1;
                .submenu-name { font-size: 14px; color: #303133; font-weight: 500; margin-bottom: 2px; }
                .submenu-desc { font-size: 12px; color: #909399; line-height: 1.2; }
              }

              .submenu-arrow {
                opacity: 0;
                transition: all 0.2s ease;
                i { font-size: 14px; color: #c0c4cc; }
              }
            }
          }
        }
      }

      .permission-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 200px;

        .column-header {
          display: flex;
          align-items: center;
          padding: 12px 16px;
          background: #f8f9fa;
          border-bottom: 1px solid #e6e6e6;
          i { font-size: 14px; color: #F56C6C; margin-right: 8px; }
          .column-title { flex: 1; font-size: 14px; font-weight: 600; color: #606266; }
          .el-tag { margin-left: 8px; }
        }

        .permission-content {
          flex: 1;
          overflow-y: auto;
          padding: 12px;

          .permission-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 8px;

            .permission-button {
              display: flex;
              align-items: center;
              padding: 10px;
              border-radius: 4px;
              background: #f8f9fa;
              border: 1px solid #e6e6e6;
              cursor: default;
              transition: all 0.2s ease;
              position: relative;

              &:hover { transform: translateY(-1px); box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); }
              &.button-add { border-left: 3px solid #67C23A; }
              &.button-edit { border-left: 3px solid #E6A23C; }
              &.button-delete { border-left: 3px solid #F56C6C; }
              &.button-view { border-left: 3px solid #409EFF; }
              &.button-export { border-left: 3px solid #909399; }
              &.button-import { border-left: 3px solid #B37FEB; }
              &.button-default { border-left: 3px solid #909399; }

              .button-icon {
                width: 24px;
                height: 24px;
                border-radius: 4px;
                background: #e6e6e6;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 10px;
                i { font-size: 14px; color: #606266; }
              }

              .button-info {
                flex: 1;
                .button-name { font-size: 12px; color: #606266; font-weight: 500; margin-bottom: 2px; }
                .button-desc { font-size: 10px; color: #909399; line-height: 1.2; }
              }

              .info-icon { font-size: 12px; color: #c0c4cc; margin-left: 8px; cursor: help; }
            }
          }
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 20px;
      border-top: 1px solid #e6e6e6;
      background: #fafbfc;

      .footer-info {
        .menu-count, .button-count { font-size: 12px; color: #909399; margin-right: 12px; }
      }
    }
  }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateX(-10px); }
  to { opacity: 1; transform: translateX(0); }
}

@media (max-width: 1200px) {
  .submenu-modal .modal-content { width: 700px; }
}

@media (max-width: 768px) {
  .sidebar-container { width: 100%; z-index: 1001; }
  .submenu-modal {
    position: fixed;
    top: 0 !important; left: 0 !important; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.5);

    .modal-content {
      width: 90%;
      height: 90%;
      margin: 5% auto;

      .dashboard-modal-body {
        .flow-steps-container {
          .flow-row {
            flex-direction: column; align-items: center;
            .flow-step {
              flex-direction: column; margin-bottom: 20px;
              .flow-arrow { margin: 10px 0; transform: rotate(90deg); }
            }
          }
        }
      }

      .modal-body {
        flex-direction: column;
        .menu-columns { flex: 2; border-right: none; border-bottom: 1px solid #e6e6e6; }
        .permission-column { flex: 1; min-height: 150px; }
      }
    }
  }
}

@media (hover: none) and (pointer: coarse) {
  .menu-item:hover .menu-arrow { opacity: 0 !important; }
  .submenu-modal { display: none; }
}
</style>